import script from "./BastianJoins.vue?vue&type=script&setup=true&lang=js"
export * from "./BastianJoins.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__